export default {"src":"/_next/static/media/custom-voices.3249b0d8.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};